// 📁 src/constants/asistentesConfig.js
// ✅ CONFIGURACIÓN VISUAL PREMIUM PARA FRONTEND — USO NO CONVERSACIONAL
// ⚠️ Este archivo solo contiene metadatos visuales (ícono, color, nombre, banner)
// 👉 Toda la lógica GPT vive en el backend (prompt, modelo, etc.)
// ✅ CORRECCIÓN: Claves en minúsculas para coincidir con los datos del backend.

const asistentesVisualConfig = {
  // 🚫 DESHABILITADOS TEMPORALMENTE - No usar en este despliegue
  // pmfast: {
  //   name: "PMFAST",
  //   icon: "BriefcaseBusiness",
  //   color: "blue",
  //   banner: {
  //     title: "PMFAST — Asistente de Certificación PMP",
  //     subtitle: "Estás conversando con el asistente PMFAST",
  //     bg: "bg-blue-900"
  //   },
  //   canCreateChat: true
  // },
  // crisis: {
  //   name: "CRISIS", 
  //   icon: "ShieldAlert",
  //   color: "rose",
  //   banner: {
  //     title: "CRISIS — Soporte en situaciones críticas",
  //     subtitle: "Estás conversando con el asistente CRISIS",
  //     bg: "bg-rose-700"
  //   },
  //   canCreateChat: false 
  // },
  // comunica: {
  //   name: "COMUNICA",
  //   icon: "MessageSquareText",
  //   color: "indigo", 
  //   banner: {
  //     title: "COMUNICA — Mejora tus habilidades de comunicación",
  //     subtitle: "Estás conversando con el asistente COMUNICA",
  //     bg: "bg-indigo-600"
  //   },
  //   canCreateChat: false
  // },
  
  // ✅ ACTIVOS PARA ESTE DESPLIEGUE
  innovafast: {
    name: "INNOVAFAST",
    icon: "Rocket", // 🚀 Innovación y lanzamiento rápido
    color: "emerald",
    banner: {
      title: "INNOVAFAST — Acelera tu proceso de innovación",
      subtitle: "Estás trabajando con la metodología INNOVAFAST",
      bg: "bg-emerald-600"
    },
    canCreateChat: true
  },
  
  // 🚀 EPL LAB BUILDER - Sistema de laboratorios educativos
  eplbuilder: {
    name: "EPL LAB BUILDER",
    icon: "Beaker", // 🧪 Laboratorios científicos/educativos
    color: "blue",
    banner: {
      title: "EPL LAB BUILDER — Crea laboratorios educativos con IA",
      subtitle: "Sistema no-code para experiencias de aprendizaje interactivas",
      bg: "bg-blue-600"
    },
    isLab: true, // Marca especial para identificar que es un sistema de laboratorios
    canCreateChat: false, // No usa sistema de chat, tiene su propia interfaz
    route: "/epl/builder" // Ruta directa al sistema EPL
  },

  // 🤖 ASB - AGENT SPARRING BUILDER - Sistema de agentes conversacionales
  asbbuilder: {
    name: "AGENT SPARRING",
    icon: "Users", // 👥 Entrenamiento con agentes
    color: "purple",
    banner: {
      title: "AGENT SPARRING BUILDER — Crea agentes de entrenamiento con IA",
      subtitle: "Sistema de agentes conversacionales para entrenamiento",
      bg: "bg-purple-600"
    },
    isLab: true, // Sistema especializado no-conversacional tradicional
    canCreateChat: false, // Tiene su propia interfaz de builder
    route: "/asb/builder", // Ruta al constructor de agentes
    showBadge: true, // Mostrar badge "Nuevo"
    adminOnly: true // Solo visible para administradores
  },

  // 🎭 ASB SIMULATOR - Simulador de conversaciones con agentes (estudiantes)
  asbsimulator: {
    name: "AGENT SPARRING",
    icon: "Theater", // 🎭 Simulación/actuación
    color: "purple",
    banner: {
      title: "AGENT SPARRING — Practica tus habilidades conversacionales",
      subtitle: "Entrena con agentes IA especializados",
      bg: "bg-purple-600"
    },
    isLab: true,
    canCreateChat: false,
    route: "/asb/simulator", // Ruta al simulador
    showBadge: true // Mostrar badge "Nuevo"
  }
};

export default asistentesVisualConfig;
// ⚠️ IMPORTANTE: Las claves ('pmfast', 'crisis', etc.) deben coincidir con el backend (chatController.js) y los JSON de lógica conversacional.
